/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
import ccTab from '@/components/common/tab/index.vue';
import contentTable from '@/components/common/more-tab-content/content-table/index.vue';

export default {
    name: 'fyjs',
    components: {ccTab, contentTable},
    data() {
        return {
            tabList: [
                {
                    name: '大事记',
                    code: 'lscj'
                },
                {
                    name: '白皮书',
                    code: 'bps'
                },
                {
                    name: '宣传片',
                    code: 'xcp'
                },
                {
                    name: '法院介绍',
                    code: 'fyjs'
                }
            ],
            hsspgk: '1001',
            safw: '1002',
            data: {},
            activeTab: 'lscj',
            zgy: {
                name: '最高人民法院',
                code: '0'
            },
            gjrmfyList: [
                {
                    name: '辽宁',
                    code: '600'
                },
                {
                    name: '天津',
                    code: '51'
                },
                {
                    name: '山东',
                    code: '1850'
                },
                {
                    name: '江苏',
                    code: '1150'
                },
                {
                    name: '上海',
                    code: '1100'
                },
                {
                    name: '湖北',
                    code: '2250'
                },
                {
                    name: '浙江',
                    code: '1300'
                },
                {
                    name: '福建',
                    code: '1600'
                },
                {
                    name: '广东',
                    code: '2550'
                },

                {
                    name: '广西',
                    code: '2750'
                },
                {
                    name: '海南',
                    code: '2900'
                }
            ],
            hsfyList: [
                {
                    name: '大连',
                    code: '732'
                },
                {
                    name: '天津',
                    code: '72'
                },
                {
                    name: '青岛',
                    code: '2010'
                },
                {
                    name: '南京',
                    code: '1151'
                },
                {
                    name: '上海',
                    code: '1129'
                },
                {
                    name: '武汉',
                    code: '2367'
                },
                {
                    name: '宁波',
                    code: '1402'
                },
                {
                    name: '厦门',
                    code: '1693'
                },
                {
                    name: '广州',
                    code: '2701'
                },
                {
                    name: '北海',
                    code: '2878'
                },
                {
                    name: '海口',
                    code: '2925'
                }
            ],
            showFgjjFy: ['0', '732', '72', '2010', '1151', '1129', '2367', '1402', '1693', '2701', '2878', '2925'],
            fgList: [],
            isToPlay: false,
            fydm: '',
            fymc: '',
            fgPage: 0,
            anchorList: [],
            activeAnchor: '1-1',
            activeFy: '',
            // 海事大事记
            hsdsjList:[
                {
                    name: '迈向海事司法强国',
                    key:'zgrmfy',
                    img:'/static/image/fyjs/hssplc/img01.png',
                    video:'https://cmt.court.gov.cn/ueditors/2022/1/12/f518de1050634e5cbb071b8471e4b283.mp4'
                },
                {
                    name: '中国国际商事法庭护航"一带一路"',
                    key:'shhsfy',
                    img:'/static/image/fyjs/hssplc/img03.png',
                    video:'https://cmt.court.gov.cn/ueditors/2022/1/12/ed5eec24f69c4649a7b320b97cc68f7a.mp4'
                },
                {
                    name: '扬帆远航-迈向国际海事司法中心',
                    key:'gspdwkfhhyqg',
                    img:'/static/image/fyjs/hssplc/img04.png',
                    video:'https://cmt.court.gov.cn/ueditors/2022/1/12/bff1267992da4a5ea2e22aa82501e8dc.mp4'
                },
                {
                    name: '”云”司法谱写海事正义新篇章',
                    key:'ysfpxhszyxpz',
                    img:'/static/image/fyjs/hssplc/img02.png',
                    video:'https://cmt.court.gov.cn/ueditors/2022/11/1/7631be15104d84e16f9697f78795d0e1.mp4'
                }
            ],
            // 海事审判历程
            hssplcList: [
                {name: '机构设立', key:'jgsl'},
                {name: '海事立法、司法解释及相关文件', key:'xgwj'},
                {name: '重要会议', key:'zyhy'}
            ],
            activeHssplc:'jgsl',
            hssplcData:{
                jgsl:[
                    {
                        time: '1984年5月24日',
                        info: '最高人民法院、原交通部（现交通运输部）联合发出《关于设立海事法院的通知》，以上海等6个水上运输法院筹备组为基础，组建上海、天津、青岛、大连、广州和武汉海事法院。自1984年6月1日起，该6个海事法院宣告成立。'
                    },
                    {
                        time: '1984年11月14日',
                        info: '第六届全国人大常委会第八次会议通过了《关于在沿海港口城市设立海事法院的决定》，正式在立法上规定了海事法院的设立、监督、管辖、审判人员任免等事项。'
                    },
                    {
                        time: '1984年11月28日',
                        info: '最高人民法院作出《关于设立海事法院几个问题的决定》，在广州、上海、青岛、天津、大连、武汉设立海事法院。海事法院管辖的地域范围包括渤海、黄海、东海及海上诸岛，南海及东沙、西沙、中沙、南沙、黄岩岛等南海诸岛在内的我国享有主权的海域以及通海可航水域。'
                    },
                    {
                        time: '1987年3月',
                        info: '最高人民法院设立交通运输审判庭，主管全国海事审判的监督和指导工作。'
                    },
                    {
                        time: '1990年3月',
                        info: '海口、厦门海事法院成立。'
                    },
                    {
                        time: '1992年12月',
                        info: '宁波海事法院成立。'
                    },
                    {
                        time: '1992年',
                        info: '武汉海事法院在南通设立派出法庭，这是全国海事法院设立的第一个派出法庭。至今，11个海事法院先后共设立40余个派出法庭。'
                    },
                    {
                        time: '1999年6月',
                        info: '中央机构编制委员会办公室、最高人民法院、原交通部、财政部联合下发《关于理顺大连等6个海事法院管理体制若干问题的意见》，将上海等首批设立的6个海事法院成建制地移交给所在省、直辖市党委和高级人民法院共同管理，彻底与原交通部及其所属企业脱钩，正式纳入国家司法体制。'
                    },
                    {
                        time: '1999年8月',
                        info: '北海海事法院成立。'
                    },
                    {
                        time: '2000年10月',
                        info: '最高人民法院调整交通运输审判庭为民事审判第四庭。'
                    },
                    {
                        time: '2019年12月',
                        info: '南京海事法院成立。'
                    }


                ],
                xgwj:[
                    {
                        time: '1992年11月7日',
                        info: '第七届全国人大常委会第二十八次会议通过《中华人民共和国海商法》，并于1993年7月1日实施。该法的实施，标志着我国海事审判有了专门的实体法，我国海事立法进入新阶段。'
                    },
                    {
                        time: '1986年至1992年',
                        info: '最高人民法院陆续制定了《关于涉外海事诉讼管辖的具体规定》《关于诉讼前扣押船舶的具体规定》《关于强制变卖被扣押船舶清偿债务的具体规定》《关于海事法院收案范围的规定》《关于审理涉外海上人身伤亡案件损害赔偿的具体规定（试行）》5个司法解释，填补了海事诉讼程序和实体裁判法律适用的空白。'
                    },
                    {
                        time: '1999年12月25日',
                        info: '最高人民法院组织起草的《中华人民共和国海事诉讼特别程序法》，经第九届全国人大常委会第十三次会议通过，在海事法治建设中具有里程碑意义，标志着我国海事法律制度体系基本形成。'
                    },
                    {
                        time: '1994年至2013年二十年间',
                        info: '最高人民法院先后制定颁布了《关于海事法院诉讼前扣押船舶的规定》' +
                            '《关于海事法院拍卖被扣押船舶清偿债务的规定》' +
                            '《关于审理船舶碰撞和触碰案件财产损害赔偿的规定》' +
                            '《关于承运人就海上货物运输向托运人、收货人或提单持有人要求赔偿的请求权时效期间的批复》' +
                            '《关于如何确定沿海、内河货物运输赔偿请求权时效期间问题的批复》《关于海事法院受理案件范围的若干规定》《关于适用<中华人民共和国海事诉讼特别程序法>若干问题的解释》《关于可否将航道养护费的缴付请求列入船舶优先权问题的批复》《关于审理海上保险纠纷案件若干问题的规定》' +
                            '《关于审理船舶碰撞纠纷案件若干问题的规定》' +
                            '《关于审理无正本提单交付货物案件适用法律若干问题的规定》' +
                            '《关于审理海事赔偿责任限制相关纠纷案件的若干规定》《关于审理船舶油污损害赔偿纠纷案件若干问题的规定》' +
                            '《关于国内水路货物运输纠纷案件法律问题的指导意见》《关于审理海上货运代理纠纷案件若干问题的规定》' +
                            '《关于海事法院可否适用小额诉讼程序问题的批复》等16个司法解释和司法文件，逐步实现了对常规性海事纠纷的“全覆盖”，保障了法律的统一、规范适用。'
                    },
                    {
                        time: '2015年至2020年',
                        info: '最高人民法院先后发布《关于扣押与拍卖船舶适用法律若干问题的规定》《关于海事法院受理案件范围的规定》《关于海事诉讼管辖问题的规定》《关于审理发生在我国管辖海域相关案件若干问题的规定》（一）（二）《关于审理海洋自然资源与生态环境损害赔偿纠纷案件若干问题的规定》《关于审理涉船员纠纷案件若干问题的规定》七个司法解释，规范统一裁判尺度。'
                    }
                ],
                zyhy:[
                    {
                        time: '1991年8月27日',
                        info: '第一次全国海事审判研讨会在天津召开。此后，由各海事法院轮流主办，每年召开一次，已经成为海事法官交流审判经验的最佳平台。'
                    },
                    {
                        time: '1997年',
                        info: '在第十七次全国法院工作会议上提出“在2010年之前将我国建设成为亚太地区海事司法中心”。'
                    },
                    {
                        time: '2001年7月',
                        info: '全国海事法院院长座谈会在宁波举行，通过了《宁波会议纪要》，就海事审判实务问题提出相关指导意见。'
                    },
                    {
                        time: '2001年10月',
                        info: '第一次全国涉外商事海事审判工作会议在深圳召开。最高人民法院决定建立中国涉外商事海事审判网站。2002年1月1日，网站开通。'
                    },
                    {
                        time: '2004年2月',
                        info: '全国海事法院派出法庭工作座谈会在深圳召开，最高人民法院对海事法院派出法庭的设立提出明确要求。'
                    },
                    {
                        time: '2004年6月23日',
                        info: '最高人民法院召开纪念海事法院成立二十周年座谈会。'
                    },
                    {
                        time: '2005年11月15日',
                        info: '第二次全国涉外商事海事审判工作会议在南京召开，发布《南京会议纪要》。'
                    },
                    {
                        time: '2006年10月26日',
                        info: '第一次全国海事审判工作会议在上海召开。'
                    },
                    {
                        time: '2009年6月25日',
                        info: '全国海事法院院长工作座谈会在上海召开。'
                    },
                    {
                        time: '2010年2月1日',
                        info: '第三次全国涉外商事海事审判工作会议在海口召开。'
                    },
                    {
                        time: '2012年7月18日',
                        info: '第二次全国海事审判工作会议在大连召开。'
                    },
                    {
                        time: '2014年9月2日',
                        info: '最高人民法院召开纪念海事法院成立三十周年座谈会，宣布我国已成为亚太地区海事司法中心。'
                    },
                    {
                        time: '2014年11月18日',
                        info: '第四次全国涉外商事海事审判工作会议在天津召开。'
                    },
                    {
                        time: '2015年12月16日',
                        info: '全国海事审判工作座谈会在青岛召开。最高人民法院在青岛设立国际海事司法研究基地暨国家法官学院青岛海事分院。'
                    },
                    {
                        time: '2016年3月',
                        info: '周强院长在第十二届全国人大四次会议做工作报告时提出“加强海事审判工作，建设国际海事司法中心”。'
                    },
                    {
                        time: '2017年6月16日',
                        info: '全国海事审判实务座谈会在大连召开。'
                    },
                    {
                        time: '2018年11月7日',
                        info: '第五次全国涉外商事海事审判工作会议在青岛召开。'
                    },
                    {
                        time: '2021年6月10日',
                        info: '全国涉外商事海事审判工作座谈会在南京召开。'
                    },
                    {
                        time: '2023年4月14日',
                        info: '第二十九届全国海事审判研讨会在北海召开。'
                    },
                    {
                        time: '2023年9月5日',
                        info: '《北京船舶司法出售公约》国际研讨会在北京国家会议中心举行。'
                    },
                    {
                        time: '2024年5月30日',
                        info: '第三十届全国海事审判研讨会在南京召开。'
                    },
                    {
                        time: '2024年11月27日',
                        info: '全国海事审判工作座谈会在北京召开。'
                    }
                ]
            },
            fbsjList:[],
            bpsCs:{
                fydm:'',
                nf:''
            }
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name: '发展历程',
                key: 'fyjs'
            }];
            const listItem = this.tabList.filter(item => item.code === this.activeTab)[0];
            listItem.key = listItem.code;
            list.push(listItem);
            return Object.freeze(list);
        },
        fgShowList() {
            return this.fgList.slice(this.fgPage * 2, (this.fgPage + 1) * 2);
        }
    },

    mounted() {
        this.getFbsj();
        this.activeTab = this.$route.query.tab || 'lscj';
        // 初始化数据
        this.changeTab(this.activeTab);
    },
    methods: {
        getFbsj() {
            this.fbsjList = [{
                name:'全部',
                key:''
            }];
            const currentYear = Number(new Date().getFullYear());
            for (let i = currentYear; i > currentYear - 13; i--) {
                this.fbsjList.push({name: i, key: i});
            }
        },
        changeFbsj(item) {
            this.bpsCs.nf = item.key;
        },
        changeTab(item) {
            this.activeTab = item;
            this.activeFy = this.zgy.code;
            this.data = {};
            if (item === 'bps') {
                this.bpsCs.fydm = Artery.deepCopy(this.activeFy);
            } else {
                this.getFyjs(this.$route.query ? (this.$route.query.code ? this.$route.query.code : this.zgy.code) : this.zgy.code);
            }
        },
        clickLeft() {
            if (this.fgPage !== 0) {
                this.fgPage--;
            }
        },
        clickRight() {
            if (this.fgPage < Math.ceil(this.fgList.length / 2) - 1) {
                this.fgPage++;
            }
        },
        moreFy() {
            this.$router.push({path: '/fyjs/fgjsMore', query: {code: this.fydm, name: this.fymc}});
        },
        scrollPage(code) {
            const dom = document.getElementById('app');
            // 删除滚动的监听事件，避免出现滚动中间乱跳动的问题
            dom.removeEventListener('scroll', this.scrollEvent);
            this.activeAnchor = code;
            // 滚动到对应的区域
            document.getElementById(`js-aim-${code}`)
                .scrollIntoView({behavior: 'smooth'});
            // 滚动结束之后，给滚动添加监听事件
            this.$nextTick(() => {
                dom.addEventListener('scroll', this.scrollEvent);
            });
        },
        initAnchor() {
            const dom = document.getElementById('app');
            dom.addEventListener('scroll', this.scrollEvent);
        },
        scrollEvent() {
            const dom = document.getElementById('app');
            const _article = document.querySelectorAll('.js-aim');
            const _height = [];
            // 获取每一块的高度
            _article.forEach((item) => {
                _height.push(item.offsetTop);
            });
            const scrollTop = dom.scrollTop;
            const anchorObj = document.getElementById('js-anchor');
            // 设置样式，默认情况下锚点对齐法院名称，滚动之后锚点固定到某个位置
            if (scrollTop > 530) {
                anchorObj.className = 'fd-anchor-item fd-fixed';
            } else {
                anchorObj.className = 'fd-anchor-item fd-relative';
            }
            // 滚动到最后的时候默认是选中最后一个锚点
            if (scrollTop + dom.clientHeight === dom.scrollHeight) {
                this.activeAnchor = `1-${this.anchorList.length}`;
            } else {
                // 循环每个模块的高度，确定滚动的位置
                _article.forEach((item, index) => {
                    if ((scrollTop >= _height[index]) && (_article[index + 1] ? scrollTop < (_height[index + 1]) : true)) {
                        this.activeAnchor = `1-${index + 1}`;
                    }
                });
            }
        },
        // 获取法院介绍信息
        getFyjs(code) {
            this.data = {
                gjfb: {
                    bt: '',
                    xwnr: ''
                },
                fyzpdz: '',
                wwFgwhList: [],
                xcpdz: '',
                fmdz: ''
            };

            if (this.activeTab === 'fyjs') {
                this.fydm = code;
                this.activeFy = code;
                window.fdGlobal.ajax({
                    method: window.fdConfig.methodGet,
                    url: window.fdConfig.url.fyjs.fyjs.replace('{fydm}', code)
                })
                    .then((res) => {
                        // 判断返回的data中是否只有一个键，如果只有一个，证明返回的数据为空（数组属性为空也会返回）
                        if (Object.keys(res.data).length > 1) {
                            this.data = res.data;
                            this.fymc = this.data.gjfb.bt;
                            this.fgList = res.data.wwFgwhList;
                            // 处理锚点定位的问题
                            this.dealAnchor();
                            this.$nextTick(() => {
                                this.initAnchor();
                            });
                        }
                    });
            } else {
                if (code === this.fydm) {
                    this.fydm = '';
                    this.activeFy = '';
                } else {
                    this.fydm = code;
                    this.activeFy = code;
                }
                this.bpsCs.fydm = Artery.deepCopy(this.fydm);
            }
        },
        // 处理锚点定位的问题
        dealAnchor() {
            this.anchorList = [];
            if (this.data.gjfb && this.data.gjfb.xwnr) {
                this.anchorList.push({name: '法院简介', code: '1-1'});
            }
            if (this.fgShowList && this.fgShowList.length) {
                this.anchorList.push({name: '法官简介', code: '1-2'});
            }
            if (this.data.fmdz) {
                this.anchorList.push({name: '法院宣传片', code: '1-3'});
            }
        },
        // 播放宣传视频
        toPlay() {
            this.isToPlay = true;
            this.$refs.videoPlayer.paused === true ? this.$refs.videoPlayer.play() : this.$refs.videoPlayer.pause();
        },
        // 获取多行省略
        getOverflowEllipsis(str, num = 145) {
            return str.length > num ? `${str.substring(0, num)}...` : str;
        },
        // 切换海事审判历程
        changeHssplc(key) {
            this.activeHssplc = key;
        },
        // 打开宣传片
        openVideo(item) {
            const url = this.$router.resolve({path: '/spbf', query: {active:'fyjs', src:item.video}});
            window.open(url.href, '_blank');
        }
    }
};

